import React, { Component } from 'react';
import {
	BrowserRouter as Router,
	HashRouter,
	Route,
	Link,
	Switch,
	Redirect
} from 'react-router-dom';
//import logo from './logo.svg';
import './App.css';

//import MenuAppBar from "./components/MenuAppBar";
import ClippedDrawer from "./components/ClippedDrawer";
import Login from "./components/Login/login";
import { Doughnut, Chart } from 'react-chartjs-2';
import axios from 'axios';
import config from './config/config'


var originalDoughnutDraw = Chart.controllers.doughnut.prototype.draw;
Chart.helpers.extend(Chart.controllers.doughnut.prototype, {
    draw: function () {
        originalDoughnutDraw.apply(this, arguments);

        var chart = this.chart;
        var color = '#000';
        var width = chart.chart.width,
            height = chart.chart.height,
            ctx = chart.chart.ctx;

        var fontSize = ((height / 130).toFixed(2));
        ctx.font = fontSize + "em sans-serif";
        ctx.textBaseline = "middle";
        ctx.fillStyle = color;

        var text1 = "65",
            text2 = "Alerts",
            textX1 = Math.round((width - ctx.measureText(text1).width) / 2),
            textY1 = (height / 2) - 15,
            textY2 = (height / 2) + 15;

        ctx.fillText(text1, textX1, textY1);

        ctx.font = ((height / 150).toFixed(2)) + "em sans-serif";
        var textX2 = Math.round((width - ctx.measureText(text2).width) / 2);
        ctx.fillText(text2, textX2, textY2);

        ctx.font = ((height / 190).toFixed(2)) + "em sans-serif";
        ctx.fillStyle = '#4a126b';
        var text3 = "25",
            text4 = "Under",
            text5 = "review",
            textX3 = Math.round(((width - ctx.measureText(text3).width) / 2) - 0.29 * width),
            textX5 = Math.round(((width - ctx.measureText(text5).width) / 2) - 0.29 * width),
            textY3 = height / 6 - 10,
            textY4 = height / 6 + 8,
            textY5 = height / 6 + 27;

        ctx.fillText(text3, textX3, textY3);

        ctx.font = ((height / 230).toFixed(2)) + "em sans-serif";
        var textX4 = Math.round(((width - ctx.measureText(text4).width) / 2) - 0.29 * width);
        ctx.fillText(text4, textX4, textY4);

        ctx.font = ((height / 190).toFixed(2)) + "em sans-serif";
        ctx.fillText(text5, textX5, textY5);

        ctx.font = ((height / 180).toFixed(2)) + "em sans-serif";
        ctx.fillStyle = '#4383cc';
        var text6 = "40",
            text7 = "Open",
            textX6 = Math.round(((width - ctx.measureText(text6).width) / 2) + 0.24 * width),
            textY6 = 5 * height / 6 - 9,
            textY7 = 5 * height / 6 + 9;

        ctx.fillText(text6, textX6, textY6);

        ctx.font = ((height / 200).toFixed(2)) + "em sans-serif";
        var textX7 = Math.round(((width - ctx.measureText(text7).width) / 2) + 0.24 * width);
        ctx.fillText(text7, textX7, textY7);
        ctx.save();
        console.log("draw1")
    }
});




class App extends Component {
	constructor(props) {
		super(props);
		this.state = {
        	logined: false,
        	username: "",
			token: "",
			routeData:[]
		};
	}

	componentWillMount(){
		const loginState = sessionStorage.getItem("loginState");
		const username = sessionStorage.getItem("username");
		const token = sessionStorage.getItem("token");
		this.setState({ logined: loginState, username: username, token: token });
	}

	login = (islogined, username, token) => {
		this.setState({ logined: islogined, username: username, token: token.token });
		sessionStorage.setItem("loginState", islogined);
		sessionStorage.setItem("username", username);
		sessionStorage.setItem("token", token.token);
	}

	logout = () => {
		this.setState({ logined: false, username: '', token: '' });
		// this.forceUpdate();
		sessionStorage.clear();
	};

	createRoute(data){
		return data.map(row=>{
			let route = row.route.toLowerCase();
			return route.substring(route.lastIndexOf('/'));
		})
	}

	componentDidMount(){
        axios.get(config.menu).then(res=>{
			// console.log("get menu")
			// console.log(res.data.results)
			// console.log(this.createRoute(res.data.results))
			this.setState({routeData:this.createRoute(res.data.results)})
		});
    }

	render() {
		//console.log(this.state.logined);
		const publicPath = '';
		//console.log(publicPath + '/login')
		return (
			<Router>
				<div className='App'>
					<Switch>
					<Route exact path={[publicPath + '/login',publicPath + "/"]} 			render={(props)=><Login {...props} login={this.login}/>}/>
					{/* <Route 
						exact path={[publicPath + '/dashboard', publicPath + '/invoice',publicPath + '/vendor',publicPath + '/transaction',publicPath + '/employee',
							publicPath + '/purchase order',publicPath + '/customer',publicPath + '/conflict of interest',publicPath + '/duplicate address',
							publicPath + '/duplicate po',publicPath + '/benford', publicPath + '/enterprise rm']} 		
						render={(props)=>this.state.logined ? 
							<ClippedDrawer {...props} username={this.state.username} token = {this.state.token}/> : 
							<Login {...props} login={this.login}/>}/> */}
					<Route 
						exact path={this.state.routeData} 		
						render={(props)=>this.state.logined ? 
							<ClippedDrawer {...props} username={this.state.username} token = {this.state.token} logout= {this.logout}/> : 
							<Login {...props} login={this.login}/>}/>
					<Route 						
						render={(props)=>this.state.logined ? 
							<ClippedDrawer {...props} username={this.state.username} token = {this.state.token} logout= {this.logout}/> : 
							<Login {...props} login={this.login}/>}/>
					</Switch>
     		   </div>
			</Router>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js